module.exports = __webpack_public_path__ + "static/img/3.98863399.jpg";